import { render, staticRenderFns } from "./DobAction.vue?vue&type=template&id=fa617dc4"
import script from "./DobAction.vue?vue&type=script&lang=ts"
export * from "./DobAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports